import { render, staticRenderFns } from "./CloseMenuIcon.vue?vue&type=template&id=ed3b0ac6&scoped=true&"
import script from "./CloseMenuIcon.vue?vue&type=script&lang=js&"
export * from "./CloseMenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./CloseMenuIcon.vue?vue&type=style&index=0&id=ed3b0ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3b0ac6",
  null
  
)

export default component.exports